import React, { useEffect } from 'react';
import { useUnit } from '@starflow/app/store';
import { getProjectState, setProjectState } from '@starflow/app/store';
import { ResizeEditor } from './ResizeEditor';

const OutpaintOverlayer = React.memo((props) => {
  const {
    element,
    viewport: { scale },
  } = props;

  const unitId = element.lastDerivativeUnitId;
  const unit = useUnit(unitId);

  // 对图片进行缩放到1倍处理，只能扩图默认不让原图放大缩小
  useEffect(() => {
    if (element && (element.scaleX !== 1 || element.scaleY !== 1)) {
      const elements = getProjectState('elements').map((el) => {
        if (el.id === element.id) {
          return {
            ...el,
            scaleX: 1,
            scaleY: 1,
          };
        }
        return el;
      });
      setProjectState({ elements });
    }
  }, [element]);

  return unitId ? <ResizeEditor {...props} unit={unit} scale={scale} /> : null;
});

export const wrapImageOverlayer = (Overlayer) =>
  React.memo((props) => {
    const { currentElementTool, isEditing, element } = props;
    const isActive = currentElementTool === 'outpaint' && isEditing;

    if (isActive && element.lastDerivativeUnitId) {
      return <OutpaintOverlayer {...props} />;
    }

    return <Overlayer {...props} />;
  });
